export const handleSubmitRecurly = async({
    payment, 
    formRef, 
    formData, 
    onSaveTokenOneTime, 
    handleSubmitError, 
    onSubmit,
    children,
    onValidateChildren
}: any) => {
    await new Promise((resolve, reject) => { 
      payment.token(formRef.current, async(error: any, token: any) => {
      const isValidatedChildren = children ? onValidateChildren() : true;

      if (error) {
        handleSubmitError(error);
        reject(error)
      }

      formData.token_id = token?.id;
      onSaveTokenOneTime && await onSaveTokenOneTime(formData.token_id)

      if (isValidatedChildren) {
        await onSubmit(formData);
      }

      resolve(token)
    });
  })
  }